/**
 * Button functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class Button {
  /**
   * Constructs a new Button instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element

    this.element.addEventListener('mouseenter', e => {
      
    })
  }
}



// WEBPACK FOOTER //
// ./components/button/index.js